import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import '../../css/InstantScreens/Instant.css';
import { ValidatorUtils, StringUtils } from '../../utils';
import Spinner from 'react-bootstrap/Spinner'

import { Routes as routes, History as history } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, InstantActions } from '../../actions';
import { Button, Input, Line, AuthCheck } from  '../../components'

class InstantRecordingsScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      session: null,
      room: null,
      compositions: [],
      loading: false,
      video_blob: null,
      playing_composition_id: '',
      room_loading: false,
      comps_loading: false,
    }
  }

  componentDidMount() {
    let props = this.props.location && this.props.location.state ? this.props.location.state.props : null;
    let token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    if (props && props.session) {
      let session = props.session;
      this.props.instantActions.getVideoRooms(token, session._id, this.updateRoomAndCompositions)
      this.setState({ ...this.state, session: session, room_loading: true });
    }
  }

  renderStartRecordingRow = (session) => {
    if (!session) {
      return null;
    }

    let token         = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    let client_name   = session.client_name;
    let client_phone  = StringUtils.displayCodePhoneNumber(session.client_phone);
    let location_name = session.location_name;
    let comps_loading = this.state.comps_loading;
    let room_loading  = this.state.room_loading;
    let has_comps     = this.state.room && this.state.room.has_compositions ? true : false;

    return <div className='flex-container-row' style={{ justifyContent: 'space-between', paddingTop: 10, paddingLeft: 15, paddingRight: 15, alignItems: 'flex-end' }}>
      <div className='flex-container-column'>
        <span style={{ fontSize: 15, color: '#575757' }}>{ client_name   }</span>
        <span style={{ fontSize: 13, color: 'grey', marginTop: -3 }}>{ client_phone  }</span>
        <span style={{ fontSize: 13, color: 'grey', marginTop: -3 }}>{ location_name }</span>
      </div>
      <div style={{ paddingBottom: 3 }}>

        { room_loading ? <div className='flex-container-row' style={{ alignItems: 'center' }}>
                          <Spinner as="span" animation="border" size='sm' style={{ color: '#1dc2ff', marginRight: 8 }} />
                          <span style={{ fontSize: 13, color: 'grey' }}>Loading Recording Data</span>
                         </div>
                       : has_comps ? null : <div className='instant-join-session-button'
                              onClick={ () => {
                                this.setState({ ...this.state, comps_loading: true });
                                this.props.instantActions.startProcessingComposition(token, session._id, this.updateCompositionStatus);
                              }}>
                          { comps_loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                                    : <span className='fas fa-sync-alt' style={{ fontSize: 16, marginRight: 8 }}/> }
                          <span style={{ fontWeight: 'bold', fontSize: 14 }}>Start Video Processing</span>
                         </div>
                       }

      </div>
    </div>
  }

  renderCompletedRecordings = () => {
    let compositions = this.state.compositions || [];

    if (compositions.length === 0) {
      return null;
    }

    let room         = this.state.room;
    let video_count  = 1;

    let recording_rows = compositions.map((composition_arr, index) => {
      let composition_obj = composition_arr && composition_arr[0] ? composition_arr[0] : null;
      if (composition_obj) {
        let display_play = this.state.playing_composition_id === composition_obj.sid;
        let loading      = display_play && !this.state.video_blob ? true : false;
        let sid          = composition_obj.sid;
        let is_completed = composition_obj.status === 'completed' ? true : false;
        let status       = composition_obj.status === 'enqueued'  ? 'Processing' : '';
            status       = composition_obj.status === 'completed' ? 'Completed'  : status;
        let room_id      = composition_obj.roomSid;
        let label        = 'Recording ' + video_count.toString();
            label        = video_count === 1 && compositions.length === 1 ? 'Recording' : label;
            video_count  = video_count + 1;

        return <div key={sid} className='flex-container-column'>
          <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: '#575757', fontSize: 14, fontWeight: display_play ? 'bold' : '' }}>{ label  }</span>
            { is_completed ? <div className='instant-join-session-button'
                                  onClick={ () => {
                                    if (display_play) {
                                      this.setState({ ...this.state, playing_composition_id: '' });
                                    } else {
                                      this.getRoomVideoBlob(room_id)
                                      this.setState({ ...this.state, playing_composition_id: composition_obj.sid });
                                    }
                                  }}>
                               { loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                                         : <span className={ display_play ? 'fas fa-times-circle' : 'fas fa-play-circle' } style={{ fontSize: 16, marginRight: 8 }}/> }
                               <span style={{ fontWeight: 'bold', fontSize: 14 }}>{ display_play ? 'Close' : 'Play' }</span>
                             </div>
                           : <span style={{ color: '#1dc2ff', fontSize: 14 }}>{ status }</span> }
          </div>
          { display_play && !loading ? <div style={{ backgroundColor: 'black', marginTop: 15 }}>
            <video width='550' height='300' src={this.state.video_blob} autoPlay controls></video>
          </div> : null }
          <Line hide={index === compositions.length - 1} style={{ marginTop: 15, marginBottom: 15, backgroundColor: '#f5f5f5' }}/>
        </div>
      }
    });

    let display_no_recordings = recording_rows.length === 0 ? true : false;

    return <div className='flex-container-column' style={{ paddingLeft: 15, paddingRight: 15 }}>
      <div style={{ color: '#575757', fontWeight: 'bold', marginBottom: 15 }}>Processed Recordings</div>
      { recording_rows }
      { display_no_recordings ? <div className='flex-container-column' style={{ textAlign: 'center', fontSize: 14, color: 'grey', paddingBottom: 25, paddingTop: 25 }}>There are no processed recordings yet</div> : null }
    </div>
  }

  render() {
    return (
      <div className="flex-container" style={{  justifyContent: 'center', alignItems: 'center' }}>
        <AuthCheck user={this.props.user} userActions={this.props.userActions} />
        <div className='instant-sign-up-container flex-container-column' style={{ width: 600 }}>

          <div className='flex-container-row' style={{ justifyContent: 'space-between', padding: 10, paddingLeft: 15, paddingRight: 15, alignItems: 'center' }}>
            <span className='fas fa-arrow-circle-left instant-back-button'
                  style={{ fontSize: 30 }}
                  onClick={ () => {
                    history.goBack();
                  }} />
            <div className='flex-container-column' style={{ alignItems: 'center' }}>
              <span style={{ fontWeight: 'bold', fontSize: 22 }}>Session Recordings</span>
              <span style={{ width: 195, height: 2, borderRadius: 2, backgroundColor: '#1dc2ff' }}></span>
            </div>
            <span className='fas fa-arrow-circle-left' style={{ fontSize: 30, color: 'white' }}></span>
          </div>

          { this.renderStartRecordingRow(this.state.session) }

          <div style={{  }}>
          <Line hide={ !this.state.compositions || this.state.compositions.length === 0 } style={{ paddingRight: 15, marginTop: 15, marginBottom: 15 }} />
          </div>

          { this.renderCompletedRecordings() }

        </div>
      </div>
    );
  }

  getRoomVideoBlob = (room_id) => {
    let token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    this.props.instantActions.getRoomVideoBuffer(token, room_id, this.setVideoBuffer);
  }

  setVideoBuffer = (buffer) => {
    let obj_url  = URL.createObjectURL(buffer);
    this.setState({ ...this.state, video_blob: obj_url });
  }

  updateRoomAndCompositions = (recording_data) => {
    this.setState({ ...this.state, room: recording_data.room, compositions: recording_data.compositions, room_loading: false });
  }

  updateCompositionStatus = (success) => {
    let token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    this.props.instantActions.getVideoRooms(token, this.state.session._id, this.updateRoomAndCompositions);
    this.setState({ ...this.state, comps_loading: false });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    instantActions: bindActionCreators(
     { ...InstantActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstantRecordingsScreen)
